import React from 'react';

import styles from './styles/feedback-button-box.module.css';

import {ReactComponent as NegativeActive} from '../../assets/chat-feedback/negative-active.svg';
import {ReactComponent as Negative} from '../../assets/chat-feedback/negative.svg';
import {ReactComponent as PositiveActive} from '../../assets/chat-feedback/positive-active.svg';
import {ReactComponent as Positive} from '../../assets/chat-feedback/positive.svg';

export default function FeedbackButtonBox({ index, answerId, feedbackType, submitFeedback, openFeedbackModal, feedbackError }) {    
    return (
       <div className={styles.wrapper}>
            <button onClick={feedbackError ? null : () => submitFeedback(answerId, 'POSITIVE')}>
                {feedbackType === 'POSITIVE' ? <PositiveActive /> : <Positive />}
            </button>
            <button onClick={feedbackError ? null : () => openFeedbackModal(answerId, index)}>
                {feedbackType === 'NEGATIVE' ? <NegativeActive /> : <Negative />}
            </button>
        </div>
    );
}
